import {useTooltipTriggerState} from '@react-stately/tooltip';
import {useTooltipTrigger} from '@react-aria/tooltip';
import {useRef} from 'react';

import {Tooltip, TooltipAvatar, TooltipTextPrimary} from '@time-webkit/all/atoms/tooltip';
import {Avatar} from '@time-webkit/all/atoms/avatar';

interface EmojiWithTooltipProps {
    emojiUrl?: string;
    emojiName: string;
}

export const EmojiWithTooltip: React.FC<EmojiWithTooltipProps> = ({emojiUrl, emojiName}) => {
    const targetRef = useRef(null);
    const tooltipState = useTooltipTriggerState({delay: 200});

    const {triggerProps, tooltipProps} = useTooltipTrigger({}, tooltipState, targetRef);

    return (
        <>
            <span
                {...triggerProps}
                onPointerDown={undefined}
                onClick={undefined}
                className='Reaction__emoji emoticon'
                style={{backgroundImage: emojiUrl && 'url(' + emojiUrl + ')'}}
                ref={targetRef}
            />
            {tooltipState.isOpen && (
                <Tooltip
                    {...tooltipProps}
                    state={tooltipState}
                    targetRef={targetRef}
                >
                    <TooltipAvatar>
                        <Avatar
                            src={emojiUrl}
                            username={emojiName}
                            size={72}
                        />
                    </TooltipAvatar>
                    <TooltipTextPrimary>{`:${emojiName}:`}</TooltipTextPrimary>
                </Tooltip>
            )}
        </>
    );
};
